import React from 'react';

import { Image } from 'expo-image';
import { StyleSheet } from 'react-native';
import { View } from 'react-native';
import { Typography } from 'ucl';

import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { UncompletedStepIcon } from '../styled';

const lockedImage = require('./locked.png');

export const LockedQuestStep = () => {
  const title = t('startOrder');
  return (
    <View style={styles.lockedStepContainer}>
      <View style={styles.image}>
        <Image source={lockedImage} style={{ width: 56, height: 56 }} />
      </View>
      <View style={styles.title}>
        <Typography style={{ margin: 0, padding: 0 }} variant="headerThree">
          {title}
        </Typography>
      </View>
      <View style={styles.icon}>
        <UncompletedStepIcon size={'4'} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  lockedStepContainer: {
    alignItems: 'center',
    minHeight: 72,
    flexDirection: 'row',
    padding: spacing.$2,
    borderRadius: 8,
    backgroundColor: primitive.$blackOpacity10,
    borderWidth: 2,
    borderColor: primitive.$blackOpacity4,
  },
  image: {
    width: 80,
    height: 56,
    alignItems: 'flex-start',
  },
  title: {
    marginLeft: spacing.$4,
    flexGrow: 1,
  },
  icon: {
    width: 16,
  },
});
